"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.math.sign");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRootElement = getRootElement;
exports.getViewportSize = getViewportSize;
exports.getDocumentScroll = getDocumentScroll;
exports.getEventPos = getEventPos;
exports.getTouchMoveDistance = getTouchMoveDistance;
exports.getEventTarget = getEventTarget;
exports.getRelativeTime = getRelativeTime;
exports.isSSR = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getRootElement() {
  var element = document.documentElement;
  return "CSS1Compat" == document.compatMode ? element : document.body || element;
}

function getViewportSize() {
  var rootElement = getRootElement();
  return [rootElement.clientWidth || window.innerWidth, rootElement.clientHeight || window.innerHeight];
}

function getDocumentScroll() {
  return [window.pageXOffset || document.documentElement && document.documentElement.scrollLeft || document.body && document.body.scrollLeft || 0, window.pageYOffset || document.documentElement && document.documentElement.scrollTop || document.body && document.body.scrollTop || 0];
}

function getEventPos(event) {
  var b = getRootElement(),
      c = getDocumentScroll();
  return [precisionRound(event.pageX || event.clientX + c[0] - (b.clientLeft || 0) || 0, 1), precisionRound(event.pageY || event.clientY + c[1] - (b.clientTop || 0) || 0, 1)];
}

function getTouchMoveDistance(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      s = _ref2[0],
      e = _ref2[1];

  return [Math.sign(e.clientX - s.clientX) * precisionRound(Math.abs(e.clientX - s.clientX), 1), Math.sign(e.clientY - s.clientY) * precisionRound(Math.abs(e.clientY - s.clientY), 1)];
}

function getEventTarget(event) {
  try {
    return event.target || event.srcElement;
  } catch (c) {
    console.warn(c);
  }
}

var startTime = new Date().valueOf();

function getRelativeTime() {
  return precisionRound((startTime ? new Date().valueOf() - startTime : 0) / 1000, 1);
}

function precisionRound(number, precision) {
  var factor = Math.pow(10, precision);
  return Math.round(number * factor) / factor;
}

;
var isSSR = typeof document === 'undefined' || typeof window === 'undefined';
exports.isSSR = isSSR;